import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismissAlert() {
    const alert = this.element.closest('.alert')
    alert.addEventListener('transitionend', () => { alert.remove() })
    alert.classList.remove('show')
  }
}
